/* eslint-disable max-len */
import { ApolloError } from '@apollo/client';
import { getRoughnessOutput } from '../../../../api';
import { manageCodeLabelColumns } from '../../../../components';
import { roughness } from '../../../../entityModel';
import { ManageRoughnesssTableBody } from './ManageRoughnessesTableBody';
import { ManageRoughnesssTableHead } from './ManageRoughnessesTableHead';

interface ManageRoughnesssTableProps {
  error?: ApolloError;
  loading: boolean;
  data?: getRoughnessOutput;
  onEdit: (roughness: roughness) => void;
  onDelete: (roughness: roughness) => void;
}

export const ManageRoughnesssTable = ({ error, loading, data, onEdit, onDelete, ...rest }: ManageRoughnesssTableProps) => {
  return (
    <table className="table table-bordered">
      <ManageRoughnesssTableHead
        columns={manageCodeLabelColumns}
      />
      <ManageRoughnesssTableBody
        columns={manageCodeLabelColumns}
        loading={loading}
        error={error}
        data={data}
        onEdit={onEdit}
        onDelete={onDelete}
      />
    </table>
  );
};
